(function ($) {
  var $bodyHtml = $("body, html");

  (function initContactForm() {
    var $switcher = $(".form-contact-us .switcher-radio-group"),
      $switcherItems = $switcher.find("li"),
      $switcherLinks = $switcher.find("a"),
      $select = $(".form-contact-us .your-user-type select");

    $switcherLinks.on("click", function (e) {
      e.preventDefault();
      $switcherItems.removeClass("active");
      $(this).closest($switcherItems).addClass("active");
      $select.find("option").attr("selected", false);
      $select
        .find("option")
        .eq($(this).closest($switcherItems).index() + 1)
        .attr("selected", "selected");
    });

    $(".form-contact-us form").on("submit", function () {
      if (!$switcherItems.filter(".active").length) {
        $switcher.addClass("switcher-radio-group_error");
      } else {
        $switcher.removeClass("switcher-radio-group_error");
      }
    });
  })();

  (function initScrollUp() {
    var $document = $(document),
      $window = $(window),
      $btnScrollTop = $(".btn-scroll-top"),
      bottomBannerClass = "btn-scroll-top_banner",
      offsetClass = "btn-scroll-top_offset",
      pageHasBottomBanner = $(".js-bottom-banner").length,
      scrollTop = 200;

    if (pageHasBottomBanner) {
      $btnScrollTop.addClass(bottomBannerClass);
    }

    $btnScrollTop.on("click", function () {
      $bodyHtml.animate(
        {
          scrollTop: 0,
        },
        400
      );
    });

    $window.on("scroll", function () {
      if (
        $window.scrollTop() >= scrollTop &&
        $btnScrollTop.hasClass("invisibe")
      ) {
        $btnScrollTop.addClass("fadeInUp").removeClass("fadeOutDown invisibe");
      } else if (
        $window.scrollTop() < scrollTop &&
        !$btnScrollTop.hasClass("invisibe")
      ) {
        $btnScrollTop.addClass("fadeOutDown invisibe").removeClass("fadeInUp");
      }
      // Offset button if bottom banner is present on the page
      if ($window.scrollTop() + $window.height() > $document.height() - 100) {
        $btnScrollTop.addClass(offsetClass);
      } else {
        $btnScrollTop.removeClass(offsetClass);
      }
    });
  })();

  (function inputFocus() {
    let $formFieldContainer = jQuery(".form-field"),
      $formField = $formFieldContainer.find(".formField-js");

    //Script ukraine phone start
    let $formFieldPhone = jQuery("#modalCMFree").find(
      ".formField-js[type=tel]"
    );

    $($formFieldPhone)
      .on("focus", function () {
        if (this.value.replace(/\D/g, "").length === 0) {
          this.value = "+38(0";
        }
      })
      .on("blur", function () {
        if (this.value.replace(/\D/g, "").length <= 4) {
          this.value = "";
        }
      })
      .on("input", function () {
        var numbers = this.value.replace(/\D/g, "");
        if (numbers.startsWith("38")) {
          numbers = numbers.substring(2);
        }
        var formatted = "+38(";
        if (numbers.length) {
          formatted += "0";
          if (numbers.length > 1) {
            formatted += numbers.substring(1, 3);
            if (numbers.length > 3) {
              formatted += ")" + numbers.substring(3, 6);
              if (numbers.length > 6) {
                formatted += "-" + numbers.substring(6, 8);
                if (numbers.length > 8) {
                  formatted += "-" + numbers.substring(8, 10);
                }
              }
            }
          }
        }
        this.value = formatted;
      })
      .on("keypress", function (e) {
        if (!/[0-9]/.test(String.fromCharCode(e.which))) {
          e.preventDefault();
        }
      });

    //Script ukraine phone end

    //Script Other phones Start
    let phoneInput = $(".col_phone input[type=tel]");

    if (phoneInput.length) {
      phoneInput.on("input", function (e) {
        let input = $(this).val();
        input = input.replace(/[^\d]/g, ""); // Удаляем все нецифровые символы
        if (input.length > 0) {
          input = "+" + input;
          if (input.length > 2) {
            input = input.substring(0, 2) + " " + input.substring(2);
          }
          if (input.length > 6) {
            input = input.substring(0, 6) + " " + input.substring(6);
          }
          if (input.length > 10) {
            input = input.substring(0, 10) + " " + input.substring(10, 19);
          }
        } else {
          input = "+";
        }
        $(this).val(input);
      });

      phoneInput.on("focus", function () {
        if ($(this).val() === "") {
          $(this).val("+");
        }
      });

      phoneInput.on("blur", function () {
        if ($(this).val() === "+") {
          $(this).val("");
        }
      });
    }
    //Script Other phones End

    $(".form-row_inline input[type=number]").keydown(function (event) {
      if (event.which === 189 || event.which === 109) {
        event.preventDefault();
      }
    });

    $formField.on("focusout", function () {
      let $currentField = jQuery(this);
      jQuery(this).parents(".form-field").removeClass("focus");
      if ($currentField.val().length > 0) {
        jQuery(this).parents(".form-field").addClass("not-empty");
      } else {
        jQuery(this).parents(".form-field").removeClass("not-empty");
      }
    });

    $formField.on("focus", function () {
      jQuery(this).parents(".form-field").addClass("focus");
    });

    $formField.each(function () {
      let $currentField = jQuery(this);
      if ($currentField.val().length > 0) {
        jQuery(this).parents(".form-field").addClass("not-empty");
        $currentField.on("change", function () {
          jQuery(this).parents(".form-field").addClass("not-empty");
        });
      }
    });
    let iwainterval = setInterval(function () {
      if (jQuery("input:-webkit-autofill")) {
        jQuery("input:-webkit-autofill").each(function () {
          jQuery(this).parents(".form-field").addClass("not-empty");
        });
      }
    }, 200);

    jQuery("select.form-control").on("select2:open", function (e) {
      jQuery(this).parents(".form-field").addClass("focus");
    });
    jQuery("select.form-control").on("select2:select", function (e) {
      jQuery(this)
        .parents(".form-field")
        .removeClass("focus")
        .addClass("not-empty");
    });
    jQuery(window).on("load", function () {
      clearInterval(iwainterval);
    });
  })();

  (function insertSiteUrlIntoForm() {
    $("[name=site-url]").each(function () {
      $(this).val(window.location.href);
    });
  })();
})(jQuery);
